var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIva(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 303 298",
    className: "b20--img",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "translate(-196 1150)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "translate(-196 1150)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    transform: "translate(81 1055)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#e)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f",
    transform: "translate(81 1055)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g",
    transform: "translate(-206 950)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h",
    transform: "translate(-115 1020)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#i",
    transform: "translate(-212 993)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j",
    transform: "translate(4 1050)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#k",
    transform: "translate(-14 1012)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(212 -950)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l",
    transform: "translate(-138 1035)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fillRule: "evenodd",
    d: "M270 97H0V0h270v97z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    fillRule: "evenodd",
    d: "M269 15c-1 0-2 0-2 1-25 48-74 77-128 77-30 0-59-9-83-25C32 51 14 28 4 1 3 0 2 0 1 0 0 1 0 2 0 3c11 27 29 51 54 68s54 26 85 26c55 0 105-30 131-79 1-1 0-2-1-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    fillRule: "evenodd",
    d: "M10 0v63H0V0h10z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f",
    fillRule: "evenodd",
    d: "M4 1c0-1-2-1-3-1S0 1 0 3c4 13 6 27 6 41 0 5 0 11-1 17 0 1 1 2 2 2s2-1 2-2c1-6 1-12 1-17 0-15-2-29-6-43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g",
    fillRule: "evenodd",
    d: "M2 151c1 0 2-1 2-2v-4c1-38 16-73 43-100C75 19 111 4 149 4s74 15 101 41c1 1 2 1 3 0v-3C225 15 188 0 149 0S73 15 45 42C17 70 1 106 0 145v4c0 1 1 2 2 2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    fillRule: "evenodd",
    d: "M98 0c-1 0-1 0-2 1-1 6 0 15-6 19-4 1-7-1-8-4v-4-1h1c0-2 0-4 1-6 0-2-3-3-4-1 0 2 0 4-1 7 0 4-2 9-4 11-5 4-6-2-7-5 3-3 5-7 6-11 0-2-4-2-4 0 0 5-4 9-9 11V9c1-3-3-3-3 0s0 6-1 10v1c0 2 0 4-1 6-1 1-3 2-5 2-1-1-2-3-2-4 0-2-3-2-4 0-1 4-5 9-10 6-4-2-3-7-2-10 4-6 11-7 16-2 1 1 3-1 2-3-7-8-20-3-22 7v4c0 1 0 2 1 3v1s1 0 1 1v1s0-1-1-2c-2 4-7 8-8 2-1-4 0-9 0-14 1-1 0-2-2-2-4 2-8 5-10 9-2 3-2 7-3 10-1 4-2 6-6 7-2 0-1 4 1 3 7-1 7-7 9-12 1-4 2-7 5-10l2-2s1 0 1-1h1l-1 1v1c-1 2-1 5-1 8 0 2 0 5 3 7 3 4 9 0 11-4 1 0 2 1 3 1 4 1 7 0 10-2v-1l2-2v-1c1-1 1-1 1-2v3c2 3 6 3 9 0 2-2 3-5 3-8h1c1-1 2-1 3-2h1c0-1 1-1 1-1l1-1-1 1c0 1 0 1-1 1 2 5 4 10 10 7 2-1 4-3 5-5-1-1-1-2-1-3v-1 1h1v1c0 1 0 1 1 1 0 1 0 1 1 2 0 0 0 1 1 1s2 1 4 1 3-1 4-1l1-1c1-1 1-2 1-3h1v-1 1c-1 1-1 2-1 3v1c-1 1-1 3-2 4-2 8-5 17-12 23-10 9-24 6-34 0 10-3 20-5 30-7 2 0 1-4-1-3-12 2-23 4-34 7-1 1-1 3 0 3 8 7 20 11 30 8 15-4 21-19 25-32 2-8 4-16 5-24 0-1-1-2-2-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "i",
    fillRule: "evenodd",
    d: "M70 99c0 1-1 1-1 2-3 6-6 13-9 19-6 9-13 18-24 21s-23 0-32-7c20-15 42-26 65-35h1c1-1 2-1 2-1s-1 1-2 1zm59-23c-12 3-24 7-36 11 2-12 3-25 5-37 0-2-4-2-4 0-1 13-3 25-4 38-5 2-10 4-15 5 2-8 4-17 5-26 2-8 3-16 3-24 17-6 35-11 53-14 12-3 26-5 38-9 10-3 18-8 22-17 1-2-2-4-3-2-4 8-11 13-20 16-12 4-25 6-38 8-18 4-35 9-52 14V29c0-2-3-2-3 0v11c-11 4-23 8-32 14-7 4-13 10-15 18-1 2 3 3 3 1 2-7 7-12 13-16 9-6 19-9 28-12 1-1 2-1 3-1 1-1 2-1 2-1h-1c0 1 0 1-1 1-1 16-4 32-8 48-1 1-1 2-1 3-17 6-33 14-49 23-7 4-14 9-21 14-1 1-1 2-1 3 8 7 19 11 30 10 11 0 20-6 27-15s13-21 17-32c3-2 7-3 11-5 2 0 3-1 4-1 1-1 2-1 2-1s-1 1-2 1c0 3-1 5-1 7s3 3 3 1c1-3 1-6 2-9 1-1 2-1 4-2l33-9c2-1 1-4-1-4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j",
    fillRule: "evenodd",
    d: "M50 0C34 0 18 2 2 3c-3 0-3 4 0 4 16-2 32-3 48-4 2 0 2-3 0-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k",
    fillRule: "evenodd",
    d: "M7 7H5L4 6c0-1 0-1 1-1v1l1 1h1zm57 1c-1-1-2-3-1-4s3 0 4 1 1 3 1 4c-2 0-3 0-4-1zm18 24c-5 1-5-8-5-12s1-8 2-11c1-1-1-3-2-2-1 0-4 1-6 2V6c-1-3-3-6-7-6-3 0-5 3-5 6s4 6 7 7h2c0 2-1 4-2 5-1 2-3 3-5 2-1-2-2-5-2-7s-3-2-3 0c0 3-1 6-3 7-4 2-6-1-7-4-1-1-3-2-3 0-2 3-5 7-9 5-4-1-5-5-4-8 3-7 12-9 16-3 1 2 4 0 3-1-6-9-19-7-22 3v6s0-1-1-1v-1c-1 3-2 7-5 8-3 0-5-1-5-3-1-5 1-11 4-14 2-1 0-3-2-2s-6 2-9 2H8V5C7 1 2-1 0 4c-1 3 1 4 3 5 1 1 2 1 2 1H4c0 2-1 3-2 4-2 1 0 4 2 3s3-4 4-7c0 1 1 0 1 0h4c1 0 2-1 3-1h0c0 1-1 1-2 1 0 1-1 2-1 3-1 4-1 8 0 11 2 3 6 4 9 3s5-4 6-6c1 2 3 3 5 4 4 1 8-1 11-4h-1v-2-1 1l1 1v1c2 2 5 4 9 3 1-1 3-2 4-3v-3-1 1c0 1 0 2 1 2 0 1 1 2 1 2l1 1c2 1 5 0 7-1 3-2 4-6 4-9-1-1-1-1-2-1h2c1 0 1 0 2-1h2l1-1h0c0 1-1 1-1 1v1c-1 4-2 8-1 13 0 4 3 11 8 10 2 0 2-3 0-3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "l",
    fillRule: "evenodd",
    d: "M167 116zm-79 18s-1 0 0 0zm34-92c2-9 3-18 6-27 1 8 1 16 1 23 0 12-4 22-9 33 0 2-1 3-2 5 1-12 2-23 4-34zm16 50s-1 0-2 1h-1c-3 0-6-2-6-5s4-9 7-7c3 1 4 6 4 9v1c-1 1-1 1-2 1zm27-17c1-2 2-5 3-7 1-1 1-2 2-2 0 0 0-1 1-1 0 1 1 1 2 2 0 1 1 2 1 3v7l-6 3c-1 0-3 1-4 2 0-2 1-5 1-7zm6-10zm4 11zm44 27c-1 0-4 1-5 3-3 3-5 6-10 6-4 0-8-2-11-5-5-4-11-12-10-19 0-2-8 1-8 3-1 7-1 15-5 22l-2 2-1-1c-1-1-2-2-2-3-3-5-3-13-3-19 0-3 1-5 1-7 4-2 8-4 11-5l6-3c0-1 1-1 2-2v-3c0-5 0-11-6-11-13 0-18 13-20 24-3 1-6 2-8 3 0-3-1-6-3-9-3-4-10-2-14 0s-11 6-10 12c1 5 5 7 10 6 1 0 3 0 4-1 1 0 1 0 2-1-1 1 0 0 0 0 1 0 2-1 3-1 0 9-1 18-3 27-3 15-7 30-11 45-4-13-6-27-8-41-1-12-1-24-1-36 3-4 5-9 8-13 5-11 10-22 11-34 2-14 1-28-3-41 0-2-7 1-7 2-6 12-9 24-11 36-2 13-4 26-5 40v12l-6 9c-2 3-4 6-5 9-1 1-2 2-2 3-1 4-2 7-3 11-1 2-1 3-2 5-2-9-2-18-2-27s0-19 2-28c0-2-8 0-8 2-1 8-3 16-5 24-3 12-8 24-14 34-2 4-4 7-7 10-2-14-2-28-1-43 1-14 2-29 5-43 0-5 1-10 3-15 1-1-3 0-3 0-4 1-7 3-10 5-5 2-10 5-14 9-11 8-22 18-29 31-5 7-8 15-9 23 0 2 8 0 8-2 3-25 25-46 46-59l2-2c-3 10-3 20-5 30-1 16-2 32-2 48 0 8 0 16 2 25 0 1 6-1 6-2 11-6 17-18 22-29 1-3 2-6 4-9 0 9 0 18 2 27 1 1 3 0 4 0 9-3 12-13 14-21 1-2 1-3 1-5 0-1 1-2 1-1 0-2 2-4 3-6 1 0 1-1 1-2 0 20 2 40 7 59 1 6 3 12 5 18 1 2 7-1 8-3 8-21 14-43 17-65 1-6 1-13 2-19v-1c2-1 5-2 7-3v1c-1 8-1 17 2 25 1 2 2 4 5 5 2 1 6-1 9-2 5-3 8-7 9-12 3 3 6 6 10 8 11 6 24 1 31-9 1-1-1-1-2-1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIva);
export default __webpack_public_path__ + "static/media/iva.98ed717cee0dfc1b2a4ca1650c6b5835.svg";
export { ForwardRef as ReactComponent };